import { render, staticRenderFns } from "./ProjectCode.vue?vue&type=template&id=bb6d3706&"
import script from "./ProjectCode.vue?vue&type=script&lang=js&"
export * from "./ProjectCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports